/**
 * Validate the contact form displayed with the [contact-form] shortcode.
 */
// CHECKED IN FUNCTIONS.PHP
//const contactFormSubmit = document.getElementById('contact-form-submit');
//if(contactFormSubmit != null) {
//  contactFormSubmit.addEventListener('click', validateForm);
//}
//var isCaptchaLoaded = false;
//var isCaptchaValidated = false;
 
function onloadCallback() {
  grecaptcha.render('#g-recaptcha', {
    'sitekey' : '6LeZD7wZAAAAADT82ueHodd1TeOEMeIDAPaL7GcM',
    'callback' : correctCaptcha
  });
  isCaptchaLoaded = true;
};

function correctCaptcha(response) {
  isCaptchaValidated = true;
};

 function validateForm(event) {
 
  event.preventDefault();
  event.stopPropagation();

  const validationMessages = [];
  /*var data_2;
  jQuery.ajax({
              type: "POST",
              url: "https://www.mithyr.com/wp-content/themes/mithis/inc/google_captcha.php",
              data: jQuery('#contact-form').serialize(),
              async:false,
              success: function(data) {
                if(data.nocaptcha==="true") {
                  data_2=1;
                } else if(data.spam==="true") {
                  data_2=1;
                } else {
                  data_2=0;
                }
              }
            });*/

  // CHECKED IN FUNCTIONS.PHP
  //if(isCaptchaLoaded==false) {
  //  validationMessages.push("Please don't spam");
  //}
  //if(isCaptchaValidated==false) {
  //  validationMessages.push('Check the captcha box');
  //}
  
  //Full name
  const fullName = document.getElementById('full-name') !== null ?
    document.getElementById('full-name').value :
    '';
 
  //Email
  const email = document.getElementById('email') !== null ?
    document.getElementById('email').value :
    '';
 
  //Message
  const message = document.getElementById('message') !== null ?
    document.getElementById('message').value :
    '';
 
  if (fullName.length === 0) {
    validationMessages.push('Please enter a valid name.');
  }
 
  if (email.length === 0 || !emailIsValid(email)) {
    validationMessages.push('Please enter a valid email address.');
  }
 
  if (message.length === 0) {
    validationMessages.push('Please enter a valid message.');
  }
 
  if (validationMessages.length === 0) {
 
     //Submit the form
     document.getElementById('contact-form').submit();
 
  } else {
 
    //Delete all the existing validation messages from the DOM
    const parent = document.getElementById('validation-messages-container');
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
 
    //Add the new validation messages to the DOM
    validationMessages.forEach(function(validationMessage, index) {
 
      //add message to the DOM
      const divElement = document.createElement('div');
      divElement.classList.add('validation-message');
      const node = document.createTextNode(validationMessage);
      divElement.appendChild(node);
 
      const element = document.getElementById('validation-messages-container');
      element.appendChild(divElement);
 
    });
 
  }
 
}
 
/**
  * A simple function that verify the email with a regular expression.
  *
  * @param email
  * @returns {boolean}
--*/
function emailIsValid(email) {
 
  const regex = /\S+@\S+\.\S+/;
  return regex.test(email);
 
}
 